import styled from 'styled-components';

export const $GoogleMap = styled.div`
  > div {
    width: 100%;
    height: 100vh;
  }
`;
